import React from 'react';
import PropTypes from 'prop-types';

export const MemberPersonalInformation = (props) => {
  const { FullName, Address, Phone, Mobile, DOB } = props;

  return (
    <>
      <h3>Personal information</h3>
      <div className="membership-info-section">
        <div className="row">
          <div className="col-xs-6 col-md-2">
            <strong>Name</strong>
          </div>
          <div className="col-xs-6 col-md-10">{FullName}</div>
        </div>
        <div className="row">
          <div className="col-xs-6 col-md-2">
            <strong>Address</strong>
          </div>
          <div className="col-xs-6 col-md-10">{Address}</div>
        </div>
        <div className="row">
          <div className="col-xs-6 col-md-2">
            <strong>Phone</strong>
          </div>
          <div className="col-xs-6 col-md-10">{Phone}</div>
        </div>
        <div className="row">
          <div className="col-xs-6 col-md-2">
            <strong>Mobile</strong>
          </div>
          <div className="col-xs-6 col-md-10">{Mobile}</div>
        </div>
        <div className="row">
          <div className="col-xs-6 col-md-2">
            <strong>Date of birth</strong>
          </div>
          <div className="col-xs-6 col-md-10">{DOB}</div>
        </div>
      </div>
    </>
  );
};

MemberPersonalInformation.propTypes = {
  FullName: PropTypes.string,
  Address: PropTypes.string,
  Phone: PropTypes.string,
  Mobile: PropTypes.string,
  DOB: PropTypes.string,
};
